import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'settlements-header',
  templateUrl: './settlements-header.component.html'
})
export class SettlementsHeaderComponent implements OnInit {
  @Input() allDepositsSum: number;
  @Input() userInfo: any;

  constructor() { }

  ngOnInit(): void {
  }


  get total() {
    return this.allDepositsSum;
  }


}
